
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      Inventories: [],
      page: 1,
      cities: [],
      users: [],
      limit: 20,
      tot_pages: 0,
      searchInventories: null,
      InventoriesSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addInventories() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addInventories",
        inputs: [
          {
            model: "manager_id",
            type: "select",
            options: (() => {
              return this.users.map((data) => {
                return { value: data.id, label: data.username };
              });
            })(),
            label: "inventors.manager",
          },
          {
            model: "city",
            type: "select",
            options: (() => {
              return this.cities.map((data) => {
                return { value: data.id, label: data.name };
              });
            })(),
            label: "inventors.city",
          },
          { model: "name", type: "text", label: "inventories.name" },
          // { model: "location", type: "text", label: "inventories.location" },
          // { model: "size", type: "text", label: "inventories.size" },
          // { model: "lat", type: "text", label: "inventories.lat" },
          // { model: "lon", type: "text", label: "inventories.lon" },
          // { model: "createdAt", type: "text", label: "inventories.createdAt" },
          // { model: "updatedAt", type: "text", label: "inventories.updatedAt" },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("inventories", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editInventories(app) {
      var data = {
        title: "popups.inventories",
        inputs: [
          {
            model: "manager_id",
            type: "text",
            label: "inventories.manager_id",
            value: app.manager_id,
          },
          {
            model: "city_id",
            type: "text",
            label: "inventories.city_id",
            value: app.city_id,
          },
          {
            model: "name",
            type: "text",
            label: "inventories.name",
            value: app.name,
          },
          {
            model: "location",
            type: "text",
            label: "inventories.location",
            value: app.location,
          },
          {
            model: "size",
            type: "text",
            label: "inventories.size",
            value: app.size,
          },
          {
            model: "lat",
            type: "text",
            label: "inventories.lat",
            value: app.lat,
          },
          {
            model: "lon",
            type: "text",
            label: "inventories.lon",
            value: app.lon,
          },
          {
            model: "createdAt",
            type: "text",
            label: "inventories.createdAt",
            value: app.createdAt,
          },
          {
            model: "updatedAt",
            type: "text",
            label: "inventories.updatedAt",
            value: app.updatedAt,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("inventories", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateInventories(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
          {
            model: "manager_id",
            type: "text",
            label: "inventories.manager_id",
          },
          { model: "city_id", type: "text", label: "inventories.city_id" },
          { model: "name", type: "text", label: "inventories.name" },
          { model: "location", type: "text", label: "inventories.location" },
          { model: "size", type: "text", label: "inventories.size" },
          { model: "lat", type: "text", label: "inventories.lat" },
          { model: "lon", type: "text", label: "inventories.lon" },
          { model: "createdAt", type: "text", label: "inventories.createdAt" },
          { model: "updatedAt", type: "text", label: "inventories.updatedAt" },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("inventories", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.InventoriesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("inventories/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.Inventories = res.data;
          console.log("######## files", this.Inventories);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.InventoriesSearchMode = false;
      this.get(this.page);
    },

    getCites() {
      this.http.get("areas").then((res) => {
        this.cities = res.data;
      });
    },
    getUsers() {
      this.http.get("users").then((res) => {
        this.users = res.data;
      });
    },
    deleteInventories(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("inventories", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      this.getCites();
      this.getUsers();
      console.log(page);
      this.http
        .post("inventories/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.Inventories = res.data;
        });
    },
  },
  created() {
    this.get(1);
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.inventories.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="InventoriesSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addInventories()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("inventories.id") }}</th>
          <!-- <th scope="col">{{ $t("inventories.manager_id") }}</th> -->
          <!-- <th scope="col">{{ $t("inventories.city_id") }}</th> -->
          <th scope="col">{{ $t("inventories.name") }}</th>
          <th scope="col">{{ $t("inventories.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in Inventories" :key="app" class="text-center">
          <td>{{ index+1 }}</td>
          <!-- <td>{{ app.user?.username }}</td> -->
          <!-- <td>{{ app.area?.name }}</td> -->
          <td colspan="1">{{ app.name }}</td>
          <!-- <td>{{ app.location }}</td>
          <td>{{ app.size }}</td>
          <td>{{ app.lat }}</td>
          <td>{{ app.lon }}</td>
          <td>{{ app.createdAt }}</td>
          <td>{{ app.updatedAt }}</td> -->
          <td  colspan="2" >
            <router-link
              class="btn btn-success mx-1"
              :to="'/inventory-logs/' + app.id"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.add_replay") }}</router-link
            >
            <a
              class="btn btn-primary mx-1"
              @click="editInventories(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteInventories(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




